<template>
    <v-dialog value="true" fullscreen hide-overlay persistent>
        <v-card tile color="#fff">
            <cabecalho-pagina :ehALei14_133="ehALei14_133"
                              :deveMostrarTempoRandomico="deveMostrarTempoRandomico"
                              :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"/>

            <v-card-text id="etapasParticipacao" class="area-conteudo">
                <h2 class="area-conteudo__titulo">{{ ehEtapaLanceFechado ? 'Etapa de Lance de Desempate' : 'Etapas de Participação' }}</h2>
                <list-loader v-if="!resumoProposta.tipo"
                             :speed="2"
                             :animate="true"
                             class="list-loader"/>
                <v-container v-else color="#fff">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-flex class="area-conteudo__linha" >
                                <v-flex class="passos" md8 sm12 offset-md2>
                                    <v-stepper alt-labels v-model="passoAtual">
                                        <v-stepper-header>
                                            <template v-for="(passo, index) in passosFiltrados">
                                                <v-divider :key="`${passo.id}-divider`" class="mt-5" v-if="index"></v-divider>
                                                <v-stepper-step
                                                    :key="`${passo.id}-step`"
                                                    :complete="passoAtual > passo.numero"
                                                    :step="passo.numero"
                                                    @click="irParaRota(passo)"
                                                >
                                                    {{ passo.titulo }}
                                                </v-stepper-step>
                                            </template>
                                        </v-stepper-header>
                                    </v-stepper>
                                </v-flex>

                                <v-flex class="status" md2>
                                    <p v-if="deveMostrarTempoRandomico && !ehEtapaLanceFechado" class="mb-0">
                                        <strong>Situação</strong><br>
                                        <span :class="{ 'pulse orange--text': resumoProposta.tempoRandomico }">
                                            <i aria-hidden="true"
                                               class="fas fa-exclamation-circle mr-1"/>
                                            {{ 'Tempo randômico' }}
                                        </span>
                                    </p>
                                  <p v-if="(deveMostrarTempoRandomico && ehEtapaLanceFechado)
                                  || !deveMostrarTempoRandomico" class="mb-0">
                                    <strong>Situação</strong><br>
                                    <span>
                                        {{ 'Em andamento' }}
                                    </span>
                                  </p>
                                </v-flex>
                            </v-flex>

                            <v-stepper v-model="passoAtual" class="mb-5">
                                <v-stepper-items>
                                    <v-stepper-content :step="passoAtual">
                                        <transition name="fade" mode="out-in">
                                            <router-view/>
                                        </transition>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import {ListLoader} from 'vue-content-loader'
import CabecalhoPagina from '@/views/pages/fornecedor/commons/cabecalho-pagina/CabecalhoPagina'

export default {
    name: 'EtapasParticipacao',
    mixins: [SmartTimerMixin],
    components: {
        CabecalhoPagina,
        ListLoader
    },
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            passoAtual: 1,
            passos: [
                {
                    id: 0,
                    numero: 1,
                    titulo: 'Termos',
                    nomeRota: 'TermoDoFornecedor'
                },
                {
                    id: 1,
                    numero: 2,
                    titulo: 'Proposta Inicial',
                    nomeRota: 'PropostaDoFornecedor'
                },
                {
                    id: 2,
                    numero: 3,
                    titulo: 'Lances',
                    nomeRota: 'LanceDoFornecedor'
                },
                {
                    id: 3,
                    numero: 3,
                    titulo: 'Protocolo',
                    nomeRota: 'ProtocoloDoFornecedor'
                }
            ]
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.verificarPassoAtualPelaRota(to))
    },
    beforeRouteUpdate(to, from, next) {
        this.verificarPassoAtualPelaRota(to)
        next()
    },
    computed: {
        ...mapState(['resumoProposta', 'compraDireta', 'parametros']),
        passosFiltrados() {
            const passosFiltrados = this.passos.filter(passo => {
                return !(this.resumoProposta.tipo === 'SEM_DISPUTA' && passo.titulo === 'Lances')
                        && !(this.resumoProposta.tipo === 'COM_DISPUTA' && passo.titulo === 'Protocolo')
            })

            if(this.ehEtapaLanceFechado){
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.passoAtual = 4
                passosFiltrados.push({id: 4, numero: 4, titulo: 'Lance Desempate', nomeRota: 'LanceDesempate'})
            }

            return passosFiltrados
        },
        ehALei14_133(){
            return this.ehLei14_133(this.compraDireta.amparoLegal)
        },
        deveMostrarTempoRandomico(){
            return (this.compraDireta.tipo === 'COM_DISPUTA' &&
                this.compraDireta.tempoRandomicoLancePreenchido &&
                this.resumoProposta.tempoRandomico)
        },
        ehCompraDiretaEmAnalise(){
            return ['EM_ANALISE', 'REANALISE'].includes(this.compraDireta.situacao)
        },
        ehEtapaLanceFechado(){
            return this.ehCompraDiretaEmAnalise && this.$route.name === 'LanceDesempate'
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.compraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
      
    },
    created() {
        this.verificarPassoAtualPelaRota(this.$router.currentRoute)
    },
    async mounted() {
        try {
            await this.buscarCompraDireta()
            await this.buscarResumoProposta()
            await this.buscarParametrosDaCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
        
        this.createSmartTimer('buscarResumoProposta', 'buscarResumoProposta', 30000, {
            autostart: true,
            immediate: true
        })
    },
    methods: {
        verificarPassoAtualPelaRota(to) {
            this.passos.forEach(passo => {
                if (to.name === passo.nomeRota) {
                    this.passoAtual = passo.numero
                }
            })
        },
        async irParaRota(passo) {
            await this.validarEnvioProposta(passo)
            await this.validarFaseDeLances(passo)
            await this.ir(passo)
        },
        ir (passo) {
            if ((this.resumoProposta.situacao === 'EM_ANALISE') || (this.resumoProposta.situacao === 'ENCERRADA')) {
                if(passo.nomeRota !== 'LanceDesempate') this.irParaMensagemEncerramento()
            } else {
                this.$router.push({
                    name: passo.nomeRota,
                    params: {
                        id: this.resumoProposta.id,
                        propostaId: this.resumoProposta.propostaId
                    }
                })
            }
        },
        validarEnvioProposta(passo) {
            if (this.resumoProposta.situacaoProposta === 'EM_ELABORACAO'
                    && (passo.nomeRota === 'ProtocoloDoFornecedor' || passo.nomeRota === 'LanceDoFornecedor')
                    && this.resumoProposta.situacao === 'ABERTA') {
                throw new Error('É necessário enviar a proposta.')
            }
        },
        validarFaseDeLances(passo) {
            if (passo.titulo !== 'Lances') return

            const ehFaseDeLances = this.resumoProposta.estaNaEtapaLances
            const ehFaseDePropostas = this.resumoProposta.estaNaEtapaPropostas

            if (!ehFaseDeLances && ehFaseDePropostas)
                throw new Error('A etapa de lances inicia após o término da etapa de propostas.')
        },
        async buscarParametrosDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_PARAMETROS)
        },
        async prazoParticipacaoEncerrado() {
            await this.buscarResumoProposta()
        },
        async buscarResumoProposta() {
            const infoObj = {
                compraDiretaId: this.$route.params.id,
                propostaId: this.$route.params.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, infoObj)
            this.verificarSituacaoCompraDireta()
        },
        async buscarCompraDireta() {
            const compraDiretaId = this.$route.params.id
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, compraDiretaId)
        },
        verificarSituacaoCompraDireta() {
            if ((this.resumoProposta.situacao === 'EM_ANALISE') || (this.resumoProposta.situacao === 'ENCERRADA')) {
                if(this.$route.name !== 'LanceDesempate')
                    this.irParaMensagemEncerramento()
            }
        },
        irParaMensagemEncerramento() {
            this.$router.push(
                {
                    name: 'MensagemEncerramento',
                    params: {
                        id: this.$route.params.id,
                        propostaId: this.$route.params.propostaId
                    }
                }
            )
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-conteudo
        padding 0
        margin 0
        overflow-y auto
        padding-top 64px

        .container
            background-color #fff

        .list-loader
            height 200px
            margin-left 10%

        &__titulo
            margin 20px auto
            padding-bottom 20px
            text-align center
            text-transform uppercase
            color #777
            font-size 20px
            border-bottom 1px solid #e9e9e9

        &__linha
            display flex
            justify-content space-between
            align-items center
            padding 0 30px


            .status
                text-align right

    @-webkit-keyframes pulse
        to
            -webkit-transform: scale(1.1)
            transform: scale(1.1)

    @keyframes pulse
        to
            -webkit-transform: scale(1.1)
            transform: scale(1.1)

    .pulse
        display inline-block
        vertical-align middle
        -webkit-transform perspective(1px) translateZ(0)
        transform perspective(1px) translateZ(0)
        box-shadow 0 0 1px transparent
        animation pulse .8s linear infinite alternate

    @media (max-width 1900px)
        .area-conteudo__linha .passos .v-stepper__header
            &:after, &:before
                width 80px

            &:before
                left 125px

            &:after
                right 125px

    @media (max-width 1265px)
        .area-conteudo__linha .passos .v-stepper__header
            &:after, &:before
                width 60px

            &:before
                left 100px

            &:after
                right 100px

    @media (max-width 960px)
        .area-conteudo
            padding-top 48px

    @media (max-width 880px)
        .area-conteudo__linha .passos .v-stepper__header
            &:before
                left 110px

            &:after
                right 110px

    @media (max-width 768px)
        .area-conteudo__linha
            flex-direction column
            text-align center
            padding 0 20px

            .relogio, .passos
                margin-bottom 1.5rem

            .passos
                width 100%
                text-align center !important

    @media (max-width 500px)
        .area-conteudo
            &__linha
                padding 0 10px

            .v-stepper__content
                padding 10px

    @media (max-width 480px)
        .area-conteudo__linha .passos .v-stepper__header
            &:after, &:before
                display none

    @media only screen and (min-width 960px)
        .area-conteudo .container
            max-width 1200px
</style>
